const {innerHeight:deviceHeight , innerWidth:deviceWidth} = window
 export default {
    deviceHeight,
    deviceWidth
}